/* eslint-disable no-undef */
(() => {
  class CartComment extends HTMLElement {
    constructor() {
      super();
      this.textarea = this.querySelector('.cart-comment__textarea');
      this.debounceTimer = null;
      this.isUpdating = false;
    }

    connectedCallback() {
      if (!this.textarea) return;

      this.loadCartComment();

      this.textarea.addEventListener('input', () => {
        this.debounceUpdate();
      });

      this.textarea.addEventListener('blur', () => {
        this.updateCartComment();
      });
    }

    async loadCartComment() {
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || '/'}cart.js`
        );
        if (!response.ok) return;

        const cartData = await response.json();
        if (cartData.attributes && cartData.attributes.order_comment) {
          this.textarea.value = cartData.attributes.order_comment;
        }
      } catch (error) {
        // Silently fail if cart fetch fails
      }
    }

    debounceUpdate() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.updateCartComment();
      }, 500);
    }

    async updateCartComment() {
      if (this.isUpdating) return;

      const comment = this.textarea.value.trim();
      this.isUpdating = true;

      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || '/'}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              attributes: {
                order_comment: comment,
              },
            }),
          }
        );

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to update cart comment');
        }
      } catch (error) {
        // Silently fail - comment will be saved on checkout
        console.warn('Failed to save cart comment:', error);
      } finally {
        this.isUpdating = false;
      }
    }
  }

  customElements.define('cart-comment', CartComment);
})();

